import { createActions } from 'redux-actions';

export const SET_INCOME_TYPES = 'setIncomeTypes';

export default createActions({}, SET_INCOME_TYPES);
